// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2_QgR","col":"styles_col__2-4OC","fulfillmentStatus":"styles_fulfillmentStatus__2emNK","emailCol":"styles_emailCol__2bcJR"};